import { memo } from 'react';
import { clsx } from 'clsx';
import type { InputHTMLAttributes, ReactNode } from 'react';
import { TextBlock } from '../../typography';
import styles from './Radio.module.scss';

interface RadioProps
    extends Pick<
        InputHTMLAttributes<HTMLInputElement>,
        'name' | 'value' | 'disabled' | 'onBlur' | 'onFocus' | 'required'
    > {
    /**
     * The state of the radio.
     */
    checked?: boolean;
    /**
     * Use secondary font size for label
     */
    secondaryLabel?: boolean;
    /**
     * The label of the radio.
     */
    children?: ReactNode;
    /**
     * Callback for onChange event handler.
     */
    onChange?: (value: boolean) => void;
    /**
     * The button style for radio.
     */
    button?: boolean;
}

/**
 * The radio component.
 */
const Radio = ({
    checked,
    children,
    onChange,
    secondaryLabel,
    button,
    ...others
}: RadioProps) => {
    return (
        <label
            className={clsx(styles.container, {
                [styles.checked]: checked,
                [styles.button]: button,
                [styles.disabled]: others.disabled,
            })}
        >
            <input
                className={clsx(styles.input, {
                    [styles.disabled]: others.disabled,
                })}
                type="radio"
                checked={checked}
                onChange={event => {
                    onChange?.(event.target.checked);
                }}
                {...others}
            />
            <span className={styles.radio}>
                <span className={styles.radioMark} />
            </span>

            {children && <TextBlock primary>{children}</TextBlock>}
        </label>
    );
};

export default memo(Radio);
